"use strict";

exports.__esModule = true;
exports.ElementPositionControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _common = require("../../common");
var _Theme = require("../../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "ElementPositionControlGroup__Container",
  componentId: "sc-raocce-0"
})(["background:", ";.", " + .", "{margin-left:8px;}"], (0, _Theme.val)("SecondaryToolbarBackground"), _core.Classes.BUTTON_GROUP, _core.Classes.BUTTON_GROUP);

/**
 * Controls for changing the position of an element.
 */
var ElementPositionControlGroup = exports.ElementPositionControlGroup = /*#__PURE__*/function (_Component) {
  function ElementPositionControlGroup() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleChange = function (_ref) {
      var horizontal = _ref[0],
        vertical = _ref[1];
      var dimensions = _this.getDimensions();
      var rowCount = dimensions.rowCount,
        columnCount = dimensions.columnCount,
        gridRowStart = dimensions.gridRowStart,
        gridRowEnd = dimensions.gridRowEnd,
        gridColumnStart = dimensions.gridColumnStart,
        gridColumnEnd = dimensions.gridColumnEnd;
      var _this$props = _this.props,
        elementEditor = _this$props.elementEditor,
        controlPaths = _this$props.controlPaths;
      var width = gridColumnEnd - gridColumnStart;
      var height = gridRowEnd - gridRowStart;
      var columnProps;
      if (horizontal === "left") {
        columnProps = {};
        columnProps.gridColumnStart = 1;
        columnProps.gridColumnEnd = columnProps.gridColumnStart + width;
      } else if (horizontal === "center") {
        columnProps = {};
        columnProps.gridColumnStart = Math.round(columnCount / 2 - width / 2);
        columnProps.gridColumnEnd = columnProps.gridColumnStart + width;
      } else if (horizontal === "right") {
        columnProps = {};
        columnProps.gridColumnEnd = columnCount + 1;
        columnProps.gridColumnStart = columnProps.gridColumnEnd - width;
      }
      var rowProps;
      if (vertical === "top") {
        rowProps = {};
        rowProps.gridRowStart = 1;
        rowProps.gridRowEnd = rowProps.gridRowStart + height;
      } else if (vertical === "center") {
        rowProps = {};
        rowProps.gridRowStart = Math.round(rowCount / 2 - height / 2);
        rowProps.gridRowEnd = rowProps.gridRowStart + height;
      } else if (vertical === "bottom") {
        rowProps = {};
        rowProps.gridRowEnd = rowCount + 1;
        rowProps.gridRowStart = rowProps.gridRowEnd - height;
      }
      elementEditor.modifyRoot(function (draft) {
        if (rowProps != null && controlPaths.x !== undefined) {
          var xElement = (0, _common.getElementAtPath)(draft, controlPaths.x);
          Object.assign(xElement.props, rowProps);
        }
        if (columnProps != null && controlPaths.y !== undefined) {
          var yElement = (0, _common.getElementAtPath)(draft, controlPaths.y);
          Object.assign(yElement.props, columnProps);
        }
      });
    };
    return _this;
  }
  _inheritsLoose(ElementPositionControlGroup, _Component);
  var _proto = ElementPositionControlGroup.prototype;
  _proto.getDimensions = function getDimensions() {
    var elementEditor = this.props.elementEditor;
    var selectedPath = elementEditor.selectedPath;
    var element = elementEditor.getElementAt(selectedPath);
    if (!element) {
      return {
        rowCount: 0,
        columnCount: 0,
        gridRowStart: 0,
        gridRowEnd: 0,
        gridColumnStart: 0,
        gridColumnEnd: 0
      };
    }
    var parent = selectedPath.length >= 2 ? elementEditor.getElementAt(selectedPath.slice(0, selectedPath.length - 2)) : undefined;
    var rowCount = 12;
    var columnCount = 12;
    if (parent != null) {
      var _parent$props = parent.props;
      rowCount = _parent$props.rowCount;
      columnCount = _parent$props.columnCount;
    }
    var _element$props = element.props,
      gridRowStart = _element$props.gridRowStart,
      gridRowEnd = _element$props.gridRowEnd,
      gridColumnStart = _element$props.gridColumnStart,
      gridColumnEnd = _element$props.gridColumnEnd;
    return {
      rowCount: rowCount,
      columnCount: columnCount,
      gridRowStart: gridRowStart,
      gridRowEnd: gridRowEnd,
      gridColumnStart: gridColumnStart,
      gridColumnEnd: gridColumnEnd
    };
  };
  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      large: true,
      minimal: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.HORIZONTAL_DISTRIBUTION,
      disabled: true
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.VERTICAL_DISTRIBUTION,
      disabled: true
    })));
  };
  return ElementPositionControlGroup;
}(_react.Component);